export default __webpack_public_path__ + "static/media/massage.fdfd1f6d.png";